import dayjs from 'dayjs';

import type { EstateAnalysis } from './analytics';

type Offer = NonNullable<EstateAnalysis['offerSearches']>['data']['items'][number];

export type OrderBy = { field: string; direction: 'asc' | 'desc' };

export const useOfferSearch = (
  data: EstateAnalysis,
  orderBy: OrderBy,
  filters: Record<string, { min: number; max: number } | string[] | undefined>
): {
  data: Offer[];
} => {
  if (!data.offerSearches) {
    return {
      data: [],
    };
  }
  const direction = orderBy.direction === 'asc' ? 1 : -1;
  let offerSearches = data.offerSearches.data.items.sort((a, b) => {
    const aValue = a[orderBy.field as keyof Offer];
    const bValue = b[orderBy.field as keyof Offer];
    if (aValue && bValue) return aValue > bValue ? direction : -1 * direction;
    if (aValue) return direction;
    return -1 * direction;
  });
  if (Object.keys(filters).length) {
    offerSearches = offerSearches.filter((offer) => {
      const isInvalid = Object.keys(filters).some((key) => {
        const condition = filters[key];
        if (!condition) return false;
        const value = offer[key as keyof Offer];
        if (typeof value === 'number' && !Array.isArray(condition)) {
          return value < condition.min || value > condition.max;
        } else if (key === 'isActive' && Array.isArray(condition)) {
          return !condition.includes(value ? 'active' : 'historic');
        } else if (key === 'startDate' && !Array.isArray(condition) && typeof value === 'string') {
          return condition.min === 0
            ? false
            : dayjs(value).isBefore(dayjs().subtract(condition.min + 1, 'day'));
        }
        return false;
      });
      return !isInvalid;
    });
  }
  return {
    data: offerSearches.slice(0, 30),
  };
};
